import { ReactElement, useEffect, useState } from "react";
import {
  CheckCircleIcon,
  MasterCard,
  ToggleButton,
  VisaCard,
} from "staysure-component-library";

import { RenewalPaymentSummary } from "@/config/app-constant";

import Styles from "./button-group.module.css";

type ButtonGroupProps = {
  setSelectedAnswer: (answerNo: number) => void;
  selectedAnswer?: number | string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  answerArray: any[];
  location?: string;
  type?: string;
  isDisable?: boolean;
  loader?: ReactElement;
  application?: "renewal" | "quote";
};

function AutoPaySectionButtonGroup({
  setSelectedAnswer,
  selectedAnswer,
  answerArray,
  location,
  type = "auto",
  isDisable,
}: Readonly<ButtonGroupProps>) {
  const [selectedId, setSelectedId] = useState<
    number | string | null | undefined
  >(selectedAnswer);

  useEffect(() => {
    setSelectedId(selectedAnswer);
  }, [selectedAnswer, selectedId]);

  const [isKeyBoardFocused, setIsKeyBoardFocused] = useState(true);

  const handleOnPressStart = (e: { pointerType: string }) => {
    if (e.pointerType === "keyboard") {
      setIsKeyBoardFocused(true);
    } else {
      setIsKeyBoardFocused(false);
    }
  };

  function getMainStyle(pageLocation: string | undefined) {
    if (pageLocation === RenewalPaymentSummary) {
      return `${Styles.next_year_renwal}`;
    }
  }

  return (
    <div data-testid="button-group-test-id" className={getMainStyle(location)}>
      {answerArray?.map(
        (answer: {
          id: number;
          label: string;
          value: boolean;
          description: string;
        }) => {
          const { id, label, description } = answer;
          const isSelected = selectedId === id;
          return (
            <ToggleButton
              isEnableExtraIcon
              extraRightIcon={
                <div
                  className={` hidden  md:flex ${
                    isSelected && id === 1
                      ? "mr-spacing-xs"
                      : "md:pr-spacing-xl"
                  } `}
                >
                  {id === 1 && (
                    <>
                      <div className=" lg:px-spacing-xxs mr-spacing-xs">
                        <VisaCard
                          data-testid="visa-card-icon"
                          fill={isSelected ? "#FFFFFF" : "#172B85"}
                          width={48}
                          height={32}
                        />
                      </div>
                      <div className="p-spacing-xxs">
                        <MasterCard
                          data-testid="master-card-icon"
                          width={40}
                          height={24}
                        />
                      </div>
                    </>
                  )}
                </div>
              }
              btnType="button"
              data-testid={`${type}-buttons-group-${id}`}
              id={`${type}-buttons-group-${id}`}
              isToggleEnable={false}
              type="button"
              key={`toggleButton-${id}`}
              onClick={() => {
                setSelectedAnswer(id);
                setSelectedId(id);
              }}
              onFocusChange={(e) => setIsKeyBoardFocused(e)}
              onPressStart={(e: { pointerType: string }) =>
                handleOnPressStart(e)
              }
              description={description}
              isActiveRightIcon
              activeRightIcon={<CheckCircleIcon />}
              isDefaultActive={isSelected}
              label={label}
              className={`${Styles.toggle_btn} ${Styles.focus_class} ${
                isKeyBoardFocused ? "keyBoardFocused" : ""
              }
                            active:bg-interactive-secondary-default active:text-dark-text-on-primary border-[1px]
                            bg-surface-neutral-option-1
                            border-interactive-secondary-default
                            text-text-on-primary w-full rounded-lg text-xs
                             ${Styles.policy_togglebtn_wrapper} text-left
                            font-body-font leading-[27px] 
                            py-spacing-s px-spacing-m hover:px-[11px] flex flex-col justify-center self-start
                            gap-grid-system-space-050
                            hover:bg-interactive-action-hovered mb-spacing-s`}
              isDisabled={isDisable}
            />
          );
        }
      )}
    </div>
  );
}

export default AutoPaySectionButtonGroup;
